import { useTranslation } from 'react-i18next';
import { AnimatedSection } from '../../../components/AnimatedSection';

export default function AboutHero() {
  const { t } = useTranslation();

  const stats = [
    { number: t('about_stat1_num'), label: t('about_stat1_label') },
    { number: t('about_stat2_num'), label: t('about_stat2_label') },
    { number: t('about_stat3_num'), label: t('about_stat3_label') },
  ];

  return (
    <section className="relative bg-slate-950 pt-32 pb-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/d42555de23bdfc1b4ee38d38433cb1fd.jpg"
          alt=""
          className="w-full h-full object-cover object-top opacity-15"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950/70 to-slate-950"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-6">
        <AnimatedSection animation="fade-in" className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-cyan-500/10 border border-cyan-500/30 rounded-full mb-6">
            <i className="ri-building-4-line text-cyan-400 text-sm"></i>
            <span className="text-cyan-400 text-sm font-medium">{t('about_badge')}</span>
          </div>
          <h1 className="text-5xl font-bold text-white mb-5 leading-tight">
            {t('about_hero_title1')}<br />
            <span className="text-cyan-400">{t('about_hero_title2')}</span>
          </h1>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            {t('about_hero_desc')}
          </p>
        </AnimatedSection>
        <AnimatedSection animation="fade-in" delay={0.2} className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl mx-auto">
          {stats.map((stat) => (
            <div key={stat.label} className="bg-white/5 border border-white/10 rounded-xl p-5 text-center">
              <div className="text-4xl font-bold text-cyan-400 mb-2">{stat.number}</div>
              <div className="text-slate-400 text-sm">{stat.label}</div>
            </div>
          ))}
        </AnimatedSection>
      </div>
    </section>
  );
}
